import {
    ReservationContractExternalTemplateDocumentFields,
    ReservationContractTemplateFileAddParameters,
} from '@mews-commander/data-access';
import { DataMappingValues } from './dataMapping/DataMappingForm';
import { TemplateDocumentFields } from './hooks/useContractFieldsQuery';

export const addFieldPrefix = (field: string): string => `field--${field}`;
export const removeFieldPrefix = (field: string): string => field.replace(/^field--/, '');

export const getAllSortedDocumentFields = (fieldsData: TemplateDocumentFields[]) =>
    fieldsData.flatMap((doc) => {
        const totalPages = doc.fields?.length ? Math.max(...doc.fields.map((field) => field.pageNumber)) : 1;
        return doc.fields
            .map((field) => ({
                ...field,
                documentName: doc.documentName,
                totalPages,
            }))
            .sort((a, b) => (a.pageNumber === b.pageNumber ? a.order - b.order : a.pageNumber - b.pageNumber));
    });

export const getFilesParameter = ({
    dataMappingFields,
    fieldsData,
}: {
    dataMappingFields: DataMappingValues;
    fieldsData: ReservationContractExternalTemplateDocumentFields[];
}): ReservationContractTemplateFileAddParameters[] => {
    return fieldsData.map((document) => ({
        externalFileId: document.documentId,
        name: document.documentName,
        fieldMappings: Object.entries(dataMappingFields).flatMap(([fieldId, identifier]) => {
            const externalFieldId = removeFieldPrefix(fieldId);
            const field = document.fields.find((f) => f.id === externalFieldId);

            return field != null
                ? [
                      {
                          externalFieldId,
                          identifier,
                          label: field.label,
                      },
                  ]
                : [];
        }),
    }));
};
